import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import router from './router'
import App from './App';
import 'ant-design-vue/dist/reset.css';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import watermark from 'watermark-dom'
const app = createApp(App);
app.use(zhCN)
app.use(router);
app.use(Antd);
app.use(watermark)

app.mount('#app');